import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountService } from './account.service';
import { BaseApiService } from './base-api.service';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { getAcceptLanguage } from '../helpers/getAcceptLanguage';

@Injectable({
  providedIn: 'root'
})
export class FinancijeIosService {

  constructor(private api: BaseApiService,
    private accountService: AccountService,) { }


  getPdf(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}finansije/IOS/ios-a4`,
      {
        komitent: params.komitent,
        naDan: params.naDan,
        konto: params.konto,
      },
      {},
      {
        headers,
        responseType: 'blob',
      }
    );
  }

  getPdfAll(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}finansije/IOS/ios-a4-all`,
      {
        odKomitenta: params.odKomitenta,
        doKomitenta: params.doKomitenta,
        naDan: params.naDan,
        konto: params.konto,
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

}
